import { Component, Input, OnInit } from '@angular/core';
import { DataStateChangeEvent, FilterService, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/service/common/common.service';
import { CompositeFilterDescriptor, process, State, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { Common } from '../../common';
import { CommonUtil } from 'src/app/common/common.util';

const flatten = filter => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

const distinctModuleName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.ModuleName === x.ModuleName) === idx);

const distinctOperation = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.Operation === x.Operation) === idx);

const distinctDisplayName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.DisplayName === x.DisplayName) === idx);


const distinctDocumentModuleName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.moduleName === x.moduleName) === idx);
const distinctDocumentName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.documentName === x.documentName) === idx);
const distinctDocumentTypeName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.documentTypeName === x.documentTypeName) === idx);
const distinctDescription = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.description === x.description) === idx);
const distinctDocumentOperation = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.operation === x.operation) === idx);
const distinctDocumentModifiedByUser = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.modifiedByUser === x.modifiedByUser) === idx);

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit {
  @Input() agreementId: string;

  constructor(private commonService: CommonService) { }

  public awardAuditGridData: GridDataResult;
  public awardAuditList: any[] = [];
  public documentGridData: GridDataResult;
  public documentAuditList: any[] = [];
  public auditSkip = 0;
  public documentSkip = 0;
  public auditPageSize = 10;
  public documentPageSize = 10;
  public typedg: 'numeric' | 'input' = 'numeric';
  public buttonCount = 5;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public reqstate: State = {
    skip: 0,
    take: 10
  };
  public awardFilter?: CompositeFilterDescriptor;
  public documentFilter?: CompositeFilterDescriptor;
  // audit column filter
  public categoryFilter: any[] = [];
  public moduleNameValue: any[] = [];
  public operation: any[] = [];
  public displayName: any[] = [];
  // document column filter
  public documentModuleName: any[] = [];
  public documentName: any[] = [];
  public documentTypeName: any[] = [];
  public description: any[] = [];
  public documentOperation: any[] = [];
  public documentModifiedByUser: any[] = [];


  auditPageChange({ skip, take }: PageChangeEvent): void {
    this.auditSkip = skip;
    this.auditPageSize = take;
  }

  auditFilterChange(filter: CompositeFilterDescriptor): void {
    this.awardFilter = filter;
    const filterData = filterBy(this.awardAuditList, filter);
    this.awardAuditGridData = process(filterData, this.reqstate);
  }

  auditDataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    this.awardAuditGridData = process(this.awardAuditList, this.reqstate);
  }

  documentPageChange({ skip, take }: PageChangeEvent): void {
    this.documentSkip = skip;
    this.documentPageSize = take;
  }

  documentFilterChange(filters: CompositeFilterDescriptor): void {
    this.documentFilter = filters;
    const filterData = filterBy(this.documentAuditList, filters);
    this.documentGridData = process(filterData, this.reqstate);
  }

  documentDataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    this.documentGridData = process(this.documentAuditList, this.reqstate);
  }

  ngOnInit(): void {
    if (this.agreementId) {
      Common.loader('show');
      this.getAwardAudits();
      this.getAuditDocuments();
    }
  }

  getAwardAudits() {
    this.commonService.getAwardAudit(this.agreementId).subscribe((response: any) => {
      if (response && response.length > 0) {
        this.awardAuditList = response;
        this.awardAuditList.forEach((element) => {
          element.LastModifiedDate = element.LastModifiedDate ? CommonUtil.UTCToLocal(element.LastModifiedDate) : null;
        });
        this.awardAuditGridData = process(this.awardAuditList, this.reqstate);
        this.moduleNameValue = distinctModuleName(this.awardAuditList.filter((x) => x.ModuleName !== ''));
        this.operation = distinctOperation(this.awardAuditList.filter((x) => x.Operation !== ''));
        this.displayName = distinctDisplayName(this.awardAuditList.filter((x) => x.DisplayName !== ''));
      }
      Common.loader('hide');
    });
  }

  getAuditDocuments() {
    this.commonService.getAuditDocuments(this.agreementId).subscribe((response: any) => {
      if (response && response.length > 0) {
        this.documentAuditList = response;
        this.documentAuditList.forEach((element: any) => {
          element.modifiedDate = element.modifiedDate ? CommonUtil.UTCToLocal(element.modifiedDate) : null;
        });
        this.documentGridData = process(this.documentAuditList, this.reqstate);
        this.documentModuleName = distinctDocumentModuleName(this.documentAuditList.filter((x) => x.moduleName !== ''));
        this.documentName = distinctDocumentName(this.documentAuditList.filter((x) => x.documentName !== ''));
        this.documentTypeName = distinctDocumentTypeName(this.documentAuditList.filter((x) => x.documentTypeName !== ''));
        this.description = distinctDescription(this.documentAuditList.filter((x) => x.description !== ''));
        this.documentOperation = distinctDocumentOperation(this.documentAuditList.filter((x) => x.operation !== ''));
        this.documentModifiedByUser = distinctDocumentModifiedByUser(this.documentAuditList.filter((x) => x.modifiedByUser !== null));
      }
      Common.loader('hide');
    });
  }

  // grid column filter
  public categoryFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
    this.categoryFilter.splice(
      0, this.categoryFilter.length,
      ...flatten(filter).map(({ value }) => value)
    );
    return this.categoryFilter;
  }

  public moduleNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'ModuleName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public operationNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'Operation',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public displayNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'DisplayName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public documentModuleNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'moduleName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public documentNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'documentName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public documentTypeNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'documentTypeName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public descriptionChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'description',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public documentOperationNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'operation',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public modifiedByUserChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'modifiedByUser',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

}
